import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectGlobalDbnTaxonomyDomainAccountMappingsListItems } from "../../../../redux/global-dbn-taxonomy-domains/selector";
import { globalDbnTaxonomyDomains } from "../../../../redux/global-dbn-taxonomy-domains/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table-manager/v1.1/table";
import storePersist from "../../../../redux/storePersist";

const GlobalDbnTaxonomyDomainAccountMappings = ({selectedDomain}: any) => {
  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const listGlobalDbnTaxonomyDomainAccountMappingsData = useSelector(selectGlobalDbnTaxonomyDomainAccountMappingsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  console.log('selectedDomain', selectedDomain)
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'DBNIEName', headerName: 'DBNIE Name', searchField: 'DBNIEName', sortable: true, filter: true, filterType: 'text', },
      { field: 'DBNPName', headerName: 'DBNP Name', searchField: 'DBNPName', sortable: true, filter: true, filterType: 'text', },
      { field: 'DBAName', headerName: 'DBA Name', searchField: 'DBAName', sortable: true, filter: true, filterType: 'text', },
      { field: 'GlobalDBNDomainName', headerName: 'Global DBN Domain Name', searchField: 'GlobalDBNDomainName', sortable: true, filter: true, filterType: 'text', },
      { field: 'IsActive', headerName: 'Is Active', searchField: 'IsActive', sortable: true, filter: true, filterType: 'boolean', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDeleted', headerName: 'Is Deleted', searchField: 'IsDeleted', sortable: true, filter: true, filterType: 'boolean', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date', },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date', },
    ]);
  }

  const fetchGlobalDbnTaxonomyDomainAccountMappings = async (filterCriteria: any = [], searchCriteria: any = [], dateCriteria: any = []) => {
    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'accountMappingslist' }))
    await dispatch(globalDbnTaxonomyDomains.accountMappingslist({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/sub-domain-dba-mappings/fetch`, entity: 'GlobalDbnTaxonomyDomains', jsonData:
      {
        "Context": {
          
        },
        "Records": [
          {
            "GlobalDBNDomainId": selectedDomain?.GlobalDBNDomainId
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "DBAName",
          "SortOrder": "DBAName",
          "isOrCondition": true,
          "isFilterConditionOr": true,
          "isSearchConditionOr": true,
          "Filters": filterCriteria,
          "Searches": searchCriteria,
          "DateCriteria": dateCriteria
        }
      }
    }))
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    fetchGlobalDbnTaxonomyDomainAccountMappings([], searchCriteria, [])
  }

  const additionButtons: any = [   
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
    {
      svg:
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
              <title>Publish DBA Domains</title>
              <path d="M6.93745 10C6.24652 10.0051 5.83076 10.0263 5.4996 10.114C3.99238 10.5131 2.96048 11.8639 3.00111 13.3847C3.01288 13.8252 3.18057 14.3696 3.51595 15.4585C4.32309 18.079 5.67958 20.3539 8.7184 20.8997C9.27699 21 9.90556 21 11.1627 21L12.8372 21C14.0943 21 14.7229 21 15.2815 20.8997C18.3203 20.3539 19.6768 18.079 20.4839 15.4585C20.8193 14.3696 20.987 13.8252 20.9988 13.3847C21.0394 11.8639 20.0075 10.5131 18.5003 10.114C18.1691 10.0263 17.7534 10.0051 17.0625 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M12 3L12 14M12 3C12.4683 3 12.8243 3.4381 13.5364 4.3143L14.5 5.5M12 3C11.5316 3 11.1756 3.4381 10.4635 4.3143L9.49995 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>,
      callback: () => handlePublishDomains(),
  },
  ];

  const handleReloadData = () => {
    fetchGlobalDbnTaxonomyDomainAccountMappings([], [], [])
  }

  const handlePublishDomains = async () => {
    const metaData: any = storePersist.get("accessTokenMetadata");
    console.log('metaData', metaData)
    const tenantId = metaData?.current?.TokenMetadata?.TenantId
    console.log('tenantId', tenantId)

    await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'publish' }));
    dispatch(globalDbnTaxonomyDomains.publish({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/sub-domain-dba-mappings/publish`,
        entity: 'globalDbnTaxonomyDomains',
        jsonData: {
            "Context": {                  
            },
            "Records": [
              {
                "TenantId": tenantId
              }
            ]
          }
    }));
}


  useEffect(() => {
    const searchCriteria: any = listGlobalDbnTaxonomyDomainAccountMappingsData?.result?.items
      ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
      ?.map((item: any) => ({
        FieldName: item.Message.SpecificationAttributeName,
      }));
    setSearchCriteriaList(searchCriteria)
  }, [listGlobalDbnTaxonomyDomainAccountMappingsData]);

 
  useEffect(() => {
    if(!selectedDomain) return;
    createColumnDefs()        
    fetchGlobalDbnTaxonomyDomainAccountMappings([], [], [])
  }, [selectedDomain, pageData, pageSize])

  return (
    <>
      {listGlobalDbnTaxonomyDomainAccountMappingsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={listGlobalDbnTaxonomyDomainAccountMappingsData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listGlobalDbnTaxonomyDomainAccountMappingsData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          // onEdit={handleEdit}
          // onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="DBA Mappings"
        />
      }
    </>
  );
};

export default GlobalDbnTaxonomyDomainAccountMappings;


